import React from "react";
import styles from "./radioGroup.module.css";
import { Radio, RadioGroup } from "react-radio-group";

const RadioButtons = ({ id, label, radioClasses = {}, key, options = [],subLabel, required=false,...radioProps }) => {
    return (
        <div className={styles.formGroup} style={radioProps?.formGroupStyleOverride} key={key}>
            {label && <label htmlFor={id} style={radioProps?.labelStyleOverride}>{label}{required&&<span className="required">*</span>}</label>}
            {subLabel && <label className={styles.subLabel}>{subLabel}</label>}

            <RadioGroup name={id} className={styles.radioGroup}  required  {...radioProps} style={radioProps.radioGroupStyleOverride}>
                {options?.map((e) => {
                    return <span style={radioClasses}>
                        <Radio  disabled={radioProps?.disabled} value={e?.value}   />  <span className={styles.name}>{e?.label}</span>
                    </span>
                })}

            </RadioGroup>
        </div>
    );
};

export default React.memo(RadioButtons);
